import styles from './Experience.module.scss';
import { experience } from '../../data/resume';

export function Experience() {
  return (
    <section className="section container" id="experience" aria-label="Experience">
      <h2 className="sectionTitle">Experience</h2>
      <div className={styles.list}>
        {experience.map(exp => (
          <article key={`${exp.company}-${exp.role}`} className={styles.item}>
            <div className={styles.top}>
              <div>
                <div className={styles.role}>{exp.role}</div>
                <div className={styles.company}>{exp.company}</div>
              </div>
              <div className={styles.period}>{exp.period}</div>
            </div>
            <ul className={styles.bullets}>
              {exp.highlights.map((h, i) => <li key={i}>{h}</li>)}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}